<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">联系客服</span>
    </div>

    <el-row class="contact-info">
      <el-col :span="12">
        <div class="contact-block">
          <div class="title">服务热线</div>
          <div class="hotline">4008-050-979</div>
          <div class="sub-info">工作日 9:00 - 18:00</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="contact-block">
          <div class="title">服务邮箱</div>
          <div class="hotline">apac.icircle@budweiserapac.com</div>
          <div class="sub-info">工作日 8：00-17：00</div>
        </div>
      </el-col>
    </el-row>

  </el-card>
</template>

<script>
export default {
  name: 'contact'
}
</script>

<style lang="scss" scoped>
.contact-info {
  padding: 100px 20px 30px 20px;

  .contact-block {
    margin: $content-middle;
    border: 1px solid $base-grey2;
    border-radius: 6px;
    padding: $content-large;
    height: 140px;
    overflow: hidden;

    .title {
      font-weight: 700;
    }

    .hotline {
      padding: 30px 0 20px 0;
      color: $base-red;
      font-size: 20px;
    }

    .main-info {
      padding: 30px 0 20px 0;
      color: $base-black;
    }

    .sub-info {
      color: $base-grey;
      line-height: 18px;
    }
  }
}
</style>
